import { showMessageError } from '@Utils/RenderUtils';
import { Button, Form, Input, Spin } from 'antd';
import React, { useMemo } from 'react';
import styles from './createTelegramBot.module.less';

function UpdateModalContent(props) {
  const [form] = Form.useForm();

  const initialValues = useMemo(() => {
    return {
      name: props?.view?.name,
      botToken: props?.view?.botToken,
      batchSize: props?.view?.batchSize,
    };
  }, [props]);

  if (props.retrievingData) {
    return (
      <div
        style={{
          width: '100%',
          minHeight: 200,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin spinning />
      </div>
    );
  }

  return (
    <Form
      initialValues={{ ...initialValues }}
      form={form}
      onFinish={async (values) => {
        try {
          await form.validateFields();

          const crc = props?.view?.crc;

          if (typeof crc !== 'undefined') {
            props.onUpdate({ ...values, crc });
          }
        } catch (err) {
          showMessageError(err);
        }
      }}
    >
      <div className={styles.content} style={{ padding: 0 }}>
        <div className={styles.input}>
          <Form.Item
            label="NAME"
            name="name"
            htmlFor="name"
            labelCol={{ style: { width: 85 } }}
          >
            <Input name="name" style={{ width: 300 }} />
          </Form.Item>
        </div>
        <div className={styles.input}>
          <Form.Item
            rules={[
              {
                pattern: /^[0-9]{8,10}:[a-zA-Z0-9_-]{35}$/,
                message: 'token is invalid',
              },
            ]}
            label="BOT TOKEN"
            name="botToken"
            htmlFor="botToken"
            labelCol={{ style: { width: 85 } }}
          >
            <Input
              name="botToken"
              autoCorrect="off"
              autoComplete="off"
              style={{ width: 300 }}
            />
          </Form.Item>
        </div>
        <div className={styles.input}>
          <Form.Item
            label="BATCH SIZE"
            name="batchSize"
            htmlFor="batchSize"
            rules={[
              { pattern: /\d+/, message: 'batch size must be an integer' },
            ]}
            labelCol={{ style: { width: 85 } }}
          >
            <Input name="batchSize" style={{ width: 300 }} />
          </Form.Item>
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          justifyContent: 'flex-end',
          marginTop: 16,
        }}
      >
        <Button onClick={props.onCancel}>Cancel</Button>
        <Button loading={props.updating} htmlType="submit" type="primary">
          Submit
        </Button>
      </div>
    </Form>
  );
}

export default UpdateModalContent;
